import { RentalManagerBrowserEnvironment } from '@zg-rentals/rental-manager-env-base';
import { isDev } from '@zg-rentals/environment-utils';

export class BrowserLoggerBindings {
  name: string;

  constructor() {
    Object.defineProperty(this, 'userToken', {
      enumerable: true,
      get: () => RentalManagerBrowserEnvironment.getInstance().user.userToken,
    });
    Object.defineProperty(this, 'impersonatorUserToken', {
      enumerable: true,
      get: () => RentalManagerBrowserEnvironment.getInstance().user.impersonatorUserToken,
    });
    Object.defineProperty(this, 'isProduction', {
      enumerable: true,
      get: () => !isDev(),
    });
    Object.defineProperty(this, 'buildId', {
      enumerable: true,
      get: () => String(__BUILD_NUMBER__),
    });
    Object.defineProperty(this, 'appName', {
      enumerable: true,
      get: () => __APP_NAME__,
    });
    Object.defineProperty(this, 'currentPage', {
      enumerable: true,
      get: () => {
        if (typeof window !== 'undefined') {
          return window.location.href;
        }
        return undefined;
      },
    });
    Object.defineProperty(this, 'userAgent', {
      enumerable: true,
      get: () => {
        if (typeof window !== 'undefined') {
          return window.navigator.userAgent;
        }
        return 'node/ssr';
      },
    });
    this.name = 'BrowserLoggerBindings';
  }
}

export const createBrowserLoggerBindings = (): BrowserLoggerBindings => {
  return new BrowserLoggerBindings();
};
